import { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  IconShareDefault,
  IconBookmarkDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { ShareModal } from '@mc/share'
import Link from 'components/Link'
import { trackBookmarkClick } from '../events'

const Social = ({
  modalTitle,
  modalShareData,
  socialLinks,
  useDeprecated = true,
}) => {
  const [showShareModal, setShowShareModal] = useState(false)
  const { t } = useTranslation('@mc/next')

  const toggleShareModalClose = () => {
    setShowShareModal(!showShareModal)
  }

  return (
    <div className='d-flex flex-lg-column align-items-center'>
      <span
        className='mc-text-h8 mc-text--uppercase mc-text--muted mc-mt-4 mc-mb-2 mc-mx-1'
        id='save'
      >
        {t('article.details.social.save')}
      </span>
      <Link
        ariaLabelledby='save'
        className='c-button c-button--symmetrical mc-corners--circle c-button--tertiary c-button--sm mc-m-1'
        href={paths.logIn()}
        isBasic
        onClick={trackBookmarkClick}
      >
        <IconBookmarkDefault className='mc-icon--3 mc-opacity--muted' />
      </Link>
      <span className='mc-text-h8 mc-text--uppercase mc-text--muted mc-mt-4 mc-mb-2 mc-mx-1'>
        {t('article.details.social.share')}
      </span>
      {socialLinks.map((social) => (
        <Button
          as='a'
          className='mc-m-1'
          href={social.linkPath}
          key={social.name}
          kind='tertiary'
          rounded
          size='small'
          target='_blank'
        >
          <span className='mc-sr-only'>
            {t('lesson.details.a11y.network', { network: social.name })}
          </span>
          {social.icon}
        </Button>
      ))}
      <Button
        className='mc-m-1'
        kind='tertiary'
        onClick={toggleShareModalClose}
        rounded
        size='small'
      >
        <IconShareDefault
          srText={t('lesson.details.a11y.network', {
            network: 'your network',
          })}
        />
      </Button>
      <ShareModal
        show={showShareModal}
        shareData={modalShareData}
        onClose={toggleShareModalClose}
        useDeprecated={useDeprecated}
        modalTitle={modalTitle}
      />
    </div>
  )
}

Social.propTypes = {
  modalShareData: PropTypes.object.isRequired,
  socialLinks: PropTypes.array.isRequired,
  useDeprecated: PropTypes.bool,
  modalTitle: PropTypes.string,
}

export default Social
